import React, { useEffect } from 'react';
import { params, shape, string as stringType } from '@thd-nucleus/data-sources';
import './store-workshops.scss';

const StoreWorkshops = () => {
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('store-workshops.ready'); }, []);

  return (
    <div className="store-workshops">
      <div className="col__6-12--md col__12-12--xs col__6-12--sm u--paddingNone">
        {/* eslint-disable */}
        <img src="https://assets.thdstatic.com/images/v1/workshops/2022_Kids_Workshop-min.jpg" className="stretchy" loading="lazy" alt="Kids Workshops" />
      </div>
      <div className="col__6-12--md col__12-12--xs col__6-12--sm workshop-text">
        <div className="u--paddingNone">
          <h3 className="u__bold u--paddingBottom">Engaging Activities for Your Future Doers</h3>
          <span className="u--paddingTop">
            Join us the 1st Saturday of every month, 9 a.m.-12 noon, to enjoy a free, hands-on workshop for kids. No registration required.
          </span>
        </div>
      </div>
    </div>
  );
};

StoreWorkshops.displayName = 'StoreWorkshops';

StoreWorkshops.dataModel = {
  product: params({ itemId: stringType().isRequired() }).shape({
    itemId: stringType(),
    dataSource: stringType(),
    identifiers: shape({
      productLabel: stringType()
    })
  })
};

export { StoreWorkshops };
